import script from "./RecoveryForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecoveryForm.vue?vue&type=script&setup=true&lang=ts"

import "./RecoveryForm.vue?vue&type=style&index=0&id=50db9496&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50db9496"]])

export default __exports__